<template>
    <div class="login">
        <div class="left ">
            <vue-particles
                    color="#fff"
                    :particleOpacity="0.7"
                    :particlesNumber="60"
                    shapeType="circle"
                    :particleSize="4"
                    linesColor="#fff"
                    :linesWidth="1"
                    :lineLinked="true"
                    :lineOpacity="0.4"
                    :linesDistance="150"
                    :moveSpeed="2"
                    :hoverEffect="true"
                    hoverMode="grab"
                    :clickEffect="true"
                    clickMode="push"
                    class="lizi"
            >
            </vue-particles>
        </div>
        <div class="zyl_login_right">
            <div class="zyl_lofo_main">
                <h1>微客云集控制台</h1>
                <template v-if="actionType === 'login'">
                    <el-form>
                        <el-form-item>
                            <input type="text"
                                   autocomplete="off"
                                   v-model="user.mobile"
                                   placeholder="请输入用户名" class="layui-input">
                            <i class="el-icon-user zyl_lofo_icon"></i>
                        </el-form-item>
                        <el-form-item>
                            <input type="password"
                                   autocomplete="off"
                                   v-model="user.password"
                                   placeholder="请输入密码" class="layui-input">
                            <i class="el-icon-lock zyl_lofo_icon"></i>
                        </el-form-item>
                        <el-form-item class="ncLoginItem">
                          <div id="ncLogin" class="nc"></div>
                        </el-form-item>
                        <el-form-item>
                            <button style="padding:10px 18px;font-size:16px;border-radius:20px;"
                                    class="layui-btn layui-btn-fluid"
                                    lay-submit="" lay-filter="demo1"
                                    @click.prevent="login">{{ loginStatus }}
                            </button>
                        </el-form-item>
                    </el-form>
                </template>
                <template v-else>
                  <div class="redTip">
                    为了您的账户安全，需要进一步验证
                  </div>
                  <div class="container">
                    <div style="margin-top: 48px">
                      <el-input v-model="offsiteForm.mobile" disabled/>
                    </div>
                    <VerificationCode v-model="offsiteForm.code"
                                anotherSendApi="offsiteLogin"
                                type="offsiteLogin"
                                :mobile="offsiteForm.mobileStr"
                                :checkFlag="true"/>
                    <el-button style="margin-top: 48px;padding:10px 18px;font-size:16px;border-radius:20px;"
                            class="layui-btn layui-btn-fluid"
                            type="primary"
                            :loading="loading"
                            @click.prevent="offsiteSubmit">{{offsiteLoginStatus}}
                    </el-button>
                  </div>
              </template>
            </div>
        </div>

    </div>
</template>

<script>
  import VerificationCode from '@/components/front/tool/VerificationCode.vue'
  import loginApi from '@/api/apis'
  import auth from '@/utils/auth'
  import crypto from '@/utils/crypto'
  export default {
    name: 'Login',
    components:{
      VerificationCode
    },
    data() {
      return {
        mobileFocus: false,
        mobileValid: false, // 手机号验证格式
        ncLogin:null,
        regUrl:auth.getRegUrl(),
        yzmIng: false,
        webName: auth.getWebname(),
        loading: false,
        loginStatus: '登 录',
        offsiteLoginStatus:'确 认',
        resetStatus: '提 交',
        registerStatus: '立即注册',
        actionType: 'login',
        offsiteForm:{
          mobile:undefined,
          mobileStr:undefined,
          code:undefined
        },
        user: {
          mobile: "",
          loginType: "0",
          password: ''
        },
        registerUser: {
          'mobile': '',
          'captcha': '',
          'password': '',
          'pwd': '',
        },
        resetPwdForm:{
          mobile:'',
          captcha:'',
          password:'',
          pwd:'',
        },
        registerRules: {
          mobile: [{required: true, message: '请输入手机号', trigger: 'blur'}],
          captcha: [{required: true, message: '请输入验证码', trigger: 'blur'}],
          password: [{required: true, message: '请输入密码', trigger: 'blur'},
            {validator: this.validatePass, trigger: 'blur'},
            {min: 6, max: 20, message: '长度在 6 到 20 个字符'},
          ],
          pwd: [{required: true, message: '请再次确认密码', trigger: 'blur'},
            {validator: this.validatePass2, trigger: 'blur'},
            {min: 6, max: 20, message: '长度在 6 到 20 个字符'}],
        },
        validatePass(rule, value, callback) {
          if (value === '') {
            callback(new Error('请输入密码'));
          } else {
            if (this.registerUser.pwd !== '') {
              this.$refs.register.validateField('pwd');
            }
            callback();
          }
        },
        validatePass2(rule, value, callback) {
          if (value === '') {
            callback(new Error('请再次输入密码'));
          } else if (value !== this.registerUser.password) {
            callback(new Error('两次输入密码不一致!'));
          } else {
            callback();
          }
        },
      }
    },
    mounted(){
      this.$nextTick(this.initNC)
    },
    methods: {
      initNC() {
        if (!this.ncLogin) {
          // 实例化nc
          // eslint-disable-next-line no-undef
          AWSC.use("nc", (state, module) => {
            var nc_token = ["FFFF0N0000000000A608", (new Date()).getTime(), Math.random()].join(':');
            // 初始化
            this.ncLogin = module.init({
              // 应用类型标识。它和使用场景标识（scene字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
              appkey: "FFFF0N0000000000A608",
              //使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的scene值，请务必正确填写。
              token: nc_token,
              trans: {"key1": "code0"},
              elementID: ["usernameID"],
              is_Opt: 0,
              language: "cn",
              isEnabled: true,
              timeout: 3000,
              times: 5,
              scene: "nc_login",
              // 声明滑动验证需要渲染的目标ID。
              renderTo: "ncLogin",
              width: '350',
              //前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将会话ID（sessionId）、签名串（sig）、请求唯一标识（token）字段记录下来，随业务请求一同发送至您的服务端调用验签。
              success: (data) => {
                console.log(data,'data');
                this.user.sessionId = data.sessionId
                this.user.slideToken = data.token
                this.user.sig = data.sig
                this.validFlag = true
              },
              // 滑动验证失败时触发该回调参数。
              fail: (failCode) => {
                window.console && console.log(failCode)
              },
              // 验证码加载出现异常时触发该回调参数。
              error: (errorCode) => {
                window.console && console.log(errorCode)
              },
            })
          })
        } else {
          this.ncLogin.reset()
        }
      },
      yzmOver() {
        this.yzmIng = false
      },
      offsiteSubmit(){
        this.loading = true
        this.loginStatus = '正在登录...'
        loginApi.login.offsiteLogin({mobile:this.offsiteForm.mobileStr,code:this.offsiteForm.code})
        .then(result=>{
          console.log(result,"result");
          this.loading = false
          auth.saveSkey(result.data.security_key)
          auth.saveToken(result.data.token)
          auth.saveUser(result.data)

          this.loginStatus = '登录成功，即将跳转...'
          setTimeout(() => {
            this.$router.push('/control')
          }, 300)
        })
        .catch(()=>{
            this.loginStatus = '确 认'
            this.loading = false
        })
      },
      login() {
        if(this.loading) return;
        if(!this.user.mobile){
          this.$message.error('请输入手机号')
          return
        }
        if(!this.user.password){
          this.$message.error('请输入密码')
          return
        }
        this.loading = true
        this.loginStatus = '正在登录...'
        const saveform = JSON.parse(JSON.stringify(this.user))
        saveform.password = crypto.encrypt(saveform.password)
        console.log(saveform,"66666666666");
        loginApi.login.login(saveform)
          .then(result => {
            console.log(result,"result");
            this.loading = false
            auth.saveSkey(result.data.security_key)
            auth.saveToken(result.data.token)
            auth.saveUser(result.data)

            this.loginStatus = '登录成功，即将跳转...'
            setTimeout(() => {
              this.$router.push('/control')
            }, 300)
          })
          .catch((err) => {
            console.log(err);
            this.loginStatus = '登 录'
            this.loading = false
            if (err.code === 2) {
              this.actionType = 'offsiteTest'
              this.offsiteForm.mobile = err.data.mobile
              this.offsiteForm.mobileStr = err.data.mobileStr
            }
          })
      },
      register() {
        if(this.loading) return;
        if(!this.registerUser.password){
          this.$message.error('请输入密码')
          return
        }
        if(!this.registerUser.pwd){
          this.$message.error('请输入确认密码')
          return
        }

        if(this.registerUser.password<6){
          this.$message.error('密码长度需大于6个字符')
          return
        }

        if(this.registerUser.password!==this.registerUser.pwd){
          this.$message.error('请保持密码一致')
          return
        }
        if(!this.registerUser.mobile){
          this.$message.error('请输入手机号')
          return
        }
        if(!this.registerUser.captcha){
          this.$message.error('请输入验证码')
          return
        }
/*        this.$refs['register'].validate((valid) => {
          console.log(valid)
        })*/
        this.loading = true
        this.registerStatus = '正在注册...'
        const saveform = JSON.parse(JSON.stringify(this.registerUser))
        saveform.password= crypto.encrypt(saveform.password)
        loginApi.doregist(saveform)
          .then(() => {
            this.$message.info('注册成功，请登录')
            this.actionType = 'login'
            this.loading = false
          })
          .catch(() => {
            this.registerStatus = '立即注册'
            this.loading = false
          })
      },

    },
  }
</script>

<style scoped lang="scss">
  @import "src/assets/styleVar.scss";
  @import "src/assets/layui.scss";

  .login {
    display: flex;
    width: 100%;
    height: 100%;

    .left {
      width: 60%;
      background-color: $green;

      .lizi {
        width: 100%;
        height: 100%;
      }
    }

    .zyl_login_right {
      flex: auto;

      .el-form .el-form-item {
        margin: $margin*2 0;
      }
    }
  }

  /* 覆盖原框架样式 */
  .layui-elem-quote {
    background-color: inherit !important;
  }

  .layui-input {
    background-color: inherit;
    padding-left: 40px;
    height: 40px;
    border-top: 0px;
    border-left: 0;
    border-right: 0;
  }

  .layui-col-space15 {
    margin: 0;
  }

  .layui-form-item {
    margin-bottom: 25px;
  }

  .layui-btn {
    background-color: $green;
    border-radius: 20px;
  }

  /* 登陆表单 */
  .zyl_login_right {
    background-color: rgb(255, 255, 255);
    width: 45%;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 99;
  }

  .zyl_lofo_main {
    width: 350px;
    height: 500px;
    margin: 20% auto 0;
  }

  .zyl_lofo_icon {
    position: absolute;
    left: 5px;
    top: 8px;
    font-size: 20px;
  }

  .zyl_lofo_main h1 {
    text-align: center;
    padding: 30px 0;
  }

  @media screen and (max-width: 768px) {
    .zyl_login_right {
      width: 100%;
      right: 0;
    }
    .zyl_lofo_main {
      width: 100%;
    }
  }

  .register {
    color: $green;
    cursor: pointer;
    float: left;
    display: block;
    margin-left: 3%;
  }

  .wjmm {
    color: $green;
    cursor: pointer;
    display: inline-block;
    float: right;
    display: block;
    margin-right: 3%;
  }


  @keyframes move {
    100% {
      transform: translate3d(0, 0, 1px) rotate(360deg);
    }
  }

  /*注册页*/
  .hqyzm {
    display: inline-block;
    position: absolute;
    width: 30%;
    height: 100%;
    right: 0;
    top: 0;
    line-height: 38px;
  }

  .hqyzm span {
    padding-left: 10px;
    color: $green;
    cursor: pointer;
  }

  .login .ljdl {
    color: $green;
    cursor: pointer;
  }
::v-deep.nc-container .nc_scale .nc_iconfont {
    box-sizing: content-box;
  }
  .ncLoginItem{
    height: 34px;
  }
.redTip{
  color:#FF4D4F;
  margin-bottom: 24px;
}
.container {
  width: 100%;
  .expired {
    opacity: 0.5;
  }

  & > div {
    margin-top: 32px;
    position: relative;

    .error {
      font-size: 12px;
      font-weight: 400;
      color: #FF4D4F;
      line-height: 24px;
      position: absolute;
      top: -24px;
      left: 0;
    }
  }

  .to-register {
    display: inline-block;
    font-size: 14px;
    font-weight: 500;
    color: #0B4FFC;
    line-height: 22px;
    cursor: pointer;
  }

  .button {
    margin-top: 8px;
    width: 368px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #0B4FFC;
    border-radius: 4px;
    font-size: 16px;
    color: #fff;
    cursor: pointer;

    &.disabled {
      opacity: 0.2;
      cursor: not-allowed;
    }
  }

  .agreement {
    font-size: 14px;
    font-weight: 400;
    margin-top: 32px;
    line-height: 22px;
    text-align: center;

    span {
      color: #FC2326;
      cursor: pointer;
    }
  }

  .code {
    width: 240px;
    margin: 48px auto;
    padding: 20px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.1);
  }

  .code-title {
    font-size: 24px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 33px;
    text-align: center;
  }
}
</style>